import { render } from "./CodeSnippet.vue?vue&type=template&id=5d902b76&scoped=true"
import script from "./CodeSnippet.vue?vue&type=script&lang=js"
export * from "./CodeSnippet.vue?vue&type=script&lang=js"

import "./CodeSnippet.vue?vue&type=style&index=0&id=5d902b76&scoped=true&lang=scss"

import exportComponent from "/var/www/testback/Frontend/sdd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d902b76"]])

export default __exports__